import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import ti from "./client-hints-parser.js";
import ni from "./user-agent-parser.js";
import { Browsers as ri, OperatingSystems as ot } from "./device-constants.js";

var si = /*#__PURE__*/function () {
  function si() {
    var _this = this;

    _classCallCheck(this, si);

    var t = navigator.userAgentData ? ti : ni;
    this.Sg = new t(), this.userAgent = navigator.userAgent, this.browser = this.Sg.tf(), this.version = this.Sg.ef(), this.Ko().then(function (t) {
      return _this.OS = t;
    }), this.language = (navigator.userLanguage || navigator.language || navigator.browserLanguage || navigator.systemLanguage || "").toLowerCase(), this.Do = si.bg(this.userAgent);
  }

  _createClass(si, [{
    key: "vg",
    value: function vg() {
      return this.browser !== ri.yg || this.version > 8;
    }
  }, {
    key: "La",
    value: function La() {
      return this.browser === ri.Bg;
    }
  }, {
    key: "qo",
    value: function qo() {
      return this.OS || null;
    }
  }, {
    key: "Ko",
    value: function Ko() {
      var _this2 = this;

      return this.OS ? Promise.resolve(this.OS) : this.Sg.Ko(si.Og).then(function (t) {
        return _this2.OS = t, t;
      });
    }
  }], [{
    key: "bg",
    value: function bg(t) {
      t = t.toLowerCase();
      var i = ["googlebot", "bingbot", "slurp", "duckduckbot", "baiduspider", "yandex", "facebookexternalhit", "sogou", "ia_archiver", "https://github.com/prerender/prerender", "aolbuild", "bingpreview", "msnbot", "adsbot", "mediapartners-google", "teoma"];

      for (var n = 0; n < i.length; n++) {
        if (-1 !== t.indexOf(i[n])) return !0;
      }

      return !1;
    }
  }]);

  return si;
}();

si.Og = [{
  string: navigator.platform,
  if: "Win",
  identity: ot.Pg
}, {
  string: navigator.platform,
  if: "Mac",
  identity: ot.kg
}, {
  string: navigator.platform,
  if: "BlackBerry",
  identity: "BlackBerry"
}, {
  string: navigator.platform,
  if: "FreeBSD",
  identity: "FreeBSD"
}, {
  string: navigator.platform,
  if: "OpenBSD",
  identity: "OpenBSD"
}, {
  string: navigator.platform,
  if: "Nintendo",
  identity: "Nintendo"
}, {
  string: navigator.platform,
  if: "SunOS",
  identity: "SunOS"
}, {
  string: navigator.platform,
  if: "PlayStation",
  identity: "PlayStation"
}, {
  string: navigator.platform,
  if: "X11",
  identity: "X11"
}, {
  string: navigator.userAgent,
  if: ["iPhone", "iPad", "iPod"],
  identity: ot.ln
}, {
  string: navigator.platform,
  if: "Pike v",
  identity: ot.ln
}, {
  string: navigator.userAgent,
  if: ["Web0S"],
  identity: "WebOS"
}, {
  string: navigator.platform,
  if: ["Linux armv7l", "Android"],
  identity: ot.xg
}, {
  string: navigator.userAgent,
  if: ["Android"],
  identity: ot.xg
}, {
  string: navigator.platform,
  if: "Linux",
  identity: "Linux"
}];
var et = new si();
export { et as default, si as BrowserDetector };